import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdsCampaignAsset } from '../classes/ads-campaign-asset';

@Injectable({
  providedIn: 'root'
})
export class AdsCampaignAssetService {

  constructor(private httpClient: HttpClient) { }

  public delete(adsCampaignId: number, adsCampaignAssetId: number): Observable<void> {
    return this.httpClient.delete<void>(`/api/media/campaigns/${adsCampaignId}/assets/${adsCampaignAssetId}`);
  }

  public get(adsCampaignId: number, adsCampaignAssetId: number): Observable<AdsCampaignAsset> {
    return this.httpClient.get<AdsCampaignAsset>(`/api/media/campaigns/${adsCampaignId}/assets/${adsCampaignAssetId}`);
  }

  public save(adsCampaignId: number, adsCampaignAssetId: number | null, adsCampaignAsset: AdsCampaignAsset): Observable<AdsCampaignAsset> {

    const formData = new FormData();

    for(const key in adsCampaignAsset) {
      if(key === 'picture') {
        formData.append(key, adsCampaignAsset[key]);
      } else if(adsCampaignAsset[key as keyof AdsCampaignAsset]) {
        formData.append(key, adsCampaignAsset[key as keyof AdsCampaignAsset].toString());
      }
    }

    return this.httpClient.post<AdsCampaignAsset>(`/api/media/campaigns/${adsCampaignId}/assets/${adsCampaignAssetId ? adsCampaignAssetId : ''}`, formData);
  }
}
